import { currencyList, chargesData } from "./StaticData"
import { TableEdit, TableSelect, TableLabel, AgInput, AgSelect, TableComboInput } from "./components/AgComponents"
import { useSnapshot } from "valtio"
import { useEffect, useState } from "react"
import {
    quoteDataRec, airChargesStore, cargoStore, configStore
} from './state/CommonState'
import ReactDOMServer from 'react-dom/server'
import Utils from "./util/Utils"
import { chargesValidationStore } from "./state/validation-stores"

export default function ChargesAirComp() {
    console.log('ChargesComp rendering')
    const data = chargesData[quoteDataRec.shipmentType]
    let [space, setSpace] = useState('')

    let imChargesStore = useSnapshot(airChargesStore)
    let a = imChargesStore.newRec
    let b = imChargesStore.editRec

    useEffect(() => {
        console.log('ChargesComp useEffect')
    }, [])
    const deleteRec = (id) => {
        if (id <= imChargesStore.initialLength) return
        const index = airChargesStore.list.findIndex(e => e.id === id)
        let records = airChargesStore.list
        records = [...records]
        records.splice(index, 1)
        for (let i = 0; i < records.length; i++) {
            records[i].id = i + 1
        }
        airChargesStore.list = records
        //console.log('AFTER DELETE=', JSON.stringify(airChargesStore.cargoList))
    }
    const Th2 = (props) => <th rowSpan="2" {...props} style={{ paddingTop: '1.5rem' }}>{props.children}</th>
    const Ts = ({ i, name, dataList }) => <TableSelect
        record={airChargesStore.list[i]} name={name} dataList={dataList} isValid={chargesValidationStore.isValidCharge(name, i)} />
    const Te = ({ i, name }) => {
        const e = airChargesStore.list[i]
        if (name === 'chargeDescription' && i < airChargesStore.initialLength)
            return <TableLabel record={airChargesStore.list[i]} name={name} />
        return (
            <TableComboInput record={airChargesStore.list[i]} name={name} />
        )
    }
    const Tn = ({ i, name }) => {
        const e = airChargesStore.list[i]
        if (e.disabled && e.disabled.indexOf(name) >= 0)
            return (
                <input disabled='true' style={{ backgroundColor: '#dddddd', border: 'none' }} />
            )
        else return (
            <TableEdit record={airChargesStore.list[i]} name={name} type='number' isValid={chargesValidationStore.isValidCharge(name, i)} />
        )
    }
    const Tsn = ({ name, dataList }) => <TableSelect
        record={airChargesStore.newRec} name={name} dataList={dataList} />
    const Ten = ({ name }) => <TableEdit record={airChargesStore.newRec} name={name} />
    const Tnn = ({ name }) => <TableEdit
        record={airChargesStore.newRec} name={name} type='numeric' />
    const ifNotFCL = () => quoteDataRec.shipmentType.indexOf('FCL') < 0

    let finalTotal = 0.0
    airChargesStore.list.map((e) => {
        let erate = configStore.getExchangeRateinr(e)
        if (!erate || erate === 0) erate = 1.0
        finalTotal += e.total * erate
    })
    return (
        <>
            <hr />
            <div className="table-container">
                <table className="table is-bordered is-striped is-narrow is-hoverable ">
                    <thead>
                        <tr>
                            <th colSpan='2'>
                                <button className="button is-small is-rounded" style={{ backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_SECONDARY }} onClick={() => {
                                    // airChargesStore.list.map((e, i) => {
                                    //     let erate = configStore.getExchangeRateinr(e)
                                    //     if (!erate || erate === 0) erate = 1.0
                                    //     erate = 1.0 // nullifying conversion for per row totals
                                    //     if (!e.perKg) e.perKg = 0
                                    //     if (!e.minimum) e.minimum = 0
                                    //     if (!e.perAWB) e.perAWB = 0
                                    //     let tots = cargoStore.totals
                                    //     let val = Number(e.perKg) * Number(tots.totTotalWeight)
                                    //     let temp = Number(e.minimum)
                                    //     if (temp > val) val = temp
                                    //     e.total = Utils.R(
                                    //         (Number(val) + Number(e.perAWB))
                                    //         * erate)
                                    // })
                                    airChargesStore.calculateChargesTotals()
                                    setSpace(space === '' ? ' ' : '')
                                }}>Click to Re-Calculate Charges</button>
                            </th>
                            <th colSpan='8'>
                                <h3 className="is-size-5 has-text-centered">Charges{space}</h3>
                            </th>
                        </tr>
                        {ifNotFCL() ?
                            <tr>
                                <th></th>
                                <th></th>
                                <th></th>
                                <th colSpan='2' className="has-text-centered">Per Unit</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr> : <></>
                        }
                        <tr>
                            <th>ID</th>
                            <th style={{ width: '20rem' }}>Charge Description</th>
                            <th>Currency</th>
                            <th>Per Kg</th>
                            <th>Minimum</th>
                            <th>Per AWB</th>
                            <th style={{ textAlign: 'right' }}>Total</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            airChargesStore.list.map((e, i) => {
                                {
                                    return <tr key={e.id}>
                                        <td >{e.id}</td>
                                        <td><Te i={i} name='chargeDescription' /></td>
                                        <td><Ts i={i} name='currency' dataList={configStore.getCurrencyList()} /></td>
                                        <td><Tn i={i} name='perKg' /></td>
                                        <td><Tn i={i} name='minimum' /></td>
                                        <td><Tn i={i} name='perAWB' /></td>
                                        <td style={{ textAlign: 'right' }}>{
                                            (e.total != 0 && e.currency != '') ? Utils.N(e.total, e.currency) : ''
                                        }</td>
                                        <td>
                                            <div className="field has-addons">
                                                {
                                                    (i >= airChargesStore.initialLength) ?
                                                        <p className="control">
                                                            <button className="button is-danger is-inverted"
                                                                onClick={() => {
                                                                    deleteRec(e.id)
                                                                    setSpace(space === '' ? ' ' : '')
                                                                }}>
                                                                <span className="icon">
                                                                    <i className="fas fa-trash"></i>
                                                                </span>
                                                            </button>
                                                        </p>
                                                        :
                                                        <></>
                                                }
                                                {
                                                    i === airChargesStore.list.length - 1 &&
                                                    (
                                                        <p className="control">
                                                            <button className="button is-success is-inverted"
                                                                onClick={() => {
                                                                    let obj = airChargesStore.newRec
                                                                    obj = { ...obj }
                                                                    airChargesStore.list.push({ ...obj, id: airChargesStore.list.length + 1 })
                                                                    setSpace(space === '' ? ' ' : '')
                                                                }}>
                                                                <span className="icon is-small">
                                                                    <i className="fas fa-plus"></i>
                                                                </span>
                                                            </button>
                                                        </p>
                                                    )
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                }
                            }
                            )
                        }
                        {/* <tr style={{ border: '2px solid grey' }}>
                            <td ></td>
                            <td><Ten name='chargeDescription'></Ten></td>
                            <td><Tsn name='currency' dataList={configStore.getCurrencyList()} /></td>
                            <td><Tnn name='perKg' /></td>
                            <td><Tnn name='minimum' /></td>
                            <td><Tnn name='perAWB' /></td>
                            <td><Tnn name='total' /></td>
                            <td>
                                <div className="field has-addons">
                                    <p className="control">
                                        <button className="button is-success is-inverted"
                                            onClick={() => {
                                                let obj = airChargesStore.newRec
                                                obj = { ...obj }
                                                airChargesStore.list.push({ ...obj, id: airChargesStore.list.length + 1 })
                                                setSpace(space === '' ? ' ' : '')
                                            }}>
                                            <span className="icon is-small">
                                                <i className="fas fa-plus"></i>
                                            </span>
                                        </button>
                                    </p>
                                </div>
                            </td>
                        </tr> */}
                        <tr>
                            <td colSpan={6}></td>
                            <td style={{ textAlign: 'right' }}><strong>{Utils.N(finalTotal)}</strong></td>
                            <td></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </>
    )
}
